import { Link, useOutletContext } from "react-router-dom"
import { VehicleTile } from "../components/VehicleTile"


export function MemberDetailsVehicles(){
	const contextData = useOutletContext();
	const vehicles = contextData.details.vehicles;
	return (
		<>
		{/* {vehicles.map(vehicle =>
			<VehicleTile
			key={vehicle.vehicle_id}
			vehicle = {vehicle}
			 />
		)} */}


		<table>
			<thead>
				<tr>
					<th>Make & Model</th>
					<th>Insurance</th>
					<th>Roadworthy Expiry</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				{vehicles.map(vehicle=>
				<tr>
					<td>{vehicle.vehicle_name} (<small>{vehicle.license_plate}</small>)</td>
					<td>{vehicle.insurance_provider ?<> {vehicle.insurance_provider} <small>{`(${vehicle.insurance_expiry})`}</small> </>: <small>{"Not provided"}</small>}</td>
					<td>{vehicle.roadworthy_expiry ? vehicle.roadworthy_expiry : <small>{"Not provided"}</small>}</td>
					<td>
						<Link to={`/dashboard/services/add_ticket`} state={{"customer_id": vehicle.customer_id,vehicle_id: vehicle.vehicle_id}} className="actions">Add Service</Link>
						{/* <Link to={`/dashboard/vehicles/${vehicle.license_plate}/add_service`} className="actions">Add Service</Link> */}
					</td>
				</tr>)}
			</tbody>
		</table>
	</>
	)
}